
import './CopTable.scss';

import { GridActionsCellItem,GridColDef } from '@mui/x-data-grid'
import { JSX } from 'react';

const editSvg = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="#757575">
        <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z" />
        <path d="M20.71 7.04a1.003 1.003 0 0 0 0-1.42L18.37 3.29a1.003 1.003 0 0 0-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.83z" />
    </svg>
);

const deleteSvg = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="#757575">
        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
    </svg>
);

const checkIconSvg =(<svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M12 1.42L10.59 0L4 6.59L1.42 4.02L0 5.43L4 9.42L12 1.42Z" fill="#0C0C0C"/>
</svg>);

type UserManagementAction = {
    buttonType: string;
    buttonLabel: string;
    buttonUrl?: string;
};

const iconByStype: Record<string, JSX.Element> = {
    edit: editSvg,
    delete: deleteSvg,
};

const USER_LIST_ADMIN = "Admin";
const USER_LIST_MANAGER = "Manager";
const USER_LIST_USER ="User";



export function getUserManagementColumn(
    userManagementActions: UserManagementAction[] = [],
    onDeleteClick?: (id: string) => void,
    actionLabel?: string,
): GridColDef[] {
    {
        return  [
            {
                field: 'name',
                headerName: 'Name',
                flex: 1,
                minWidth: 150,
                filterable: false,
                valueGetter: (_, row) =>
                    `${row.firstname || ''} ${row.lastname || ''}`.trim(),
                renderCell: (params) => (
                    <span>
                    {params.row.firstname} {params.row.lastname}
                    </span>
                ),
            },
            {
                field: 'email',
                headerName: 'Email',
                flex: 0.8,
                minWidth: 130,
                filterable:false,
            },
            {
                field: 'function',
                headerName: 'Function',
                flex: 0.8,
                minWidth: 130,
                filterable:false,
            },
            {
                field: 'latestActivity',
                headerName: 'Latest Activity',
                flex: 0.7,
                minWidth: 120,
                filterable:false,
                valueGetter: (value: string | null) => {
                    if (!value) return '';
                    const date = new Date(value);
                    if (Number.isNaN(date.getTime())) return value;
                    const mm = String(date.getMonth() + 1).padStart(2, '0');
                    const dd = String(date.getDate()).padStart(2, '0');
                    const yyyy = date.getFullYear();
                    return `${mm}/${dd}/${yyyy}`;
                },
            },
            {
                field: 'state',
                headerName: 'Status',
                flex: 0.7,
                minWidth: 120,
                filterable:false,
            },
            {
                field: 'type',
                headerName: 'Type',
                flex: 0.7,
                minWidth: 120,
                filterable:false,
                valueGetter: (_, row) => {
                    if (row.isSystemAdmin) {
                        return USER_LIST_ADMIN;
                    } else if (row.isUserManager) {
                        return USER_LIST_MANAGER;
                    }
                    return USER_LIST_USER;
                }
            },
            {
                field: 'isAssignedToAnyAccount',
                headerName: 'Is Assigned To Any Account',
                flex: 0.7,
                minWidth: 120,
                filterable:false,
                renderCell: (params) => {
                    const isAssignedToAnyTenant = params.row
                        .isAssignedToAnyTenant as boolean;

                    return isAssignedToAnyTenant ? checkIconSvg : null;
                }
            },
            {
                field: 'actions',
                headerName: actionLabel || 'Actions',
                type: 'actions',
                flex: 0.5,
                minWidth: 110,
                sortable: false,
                disableColumnMenu: true,
                getActions: (params) =>
                    userManagementActions.map((action) => (
                        <GridActionsCellItem
                            key={action.buttonType}
                            icon={iconByStype[action.buttonType] ?? editSvg}
                            label={action.buttonLabel}
                            showInMenu
                            onClick={() => {
                                if (action.buttonType === 'delete') {
                                    onDeleteClick?.(String(params.row.id));
                                } else if (action.buttonUrl) {
                                    window.location.href = `${action.buttonUrl}/${params.row.id}`;
                                }
                            }}
                        />
                    )),
            },
        ]
    } }